import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';

export const GET_RENEWALS_QUERY_KEY = 'GET_RENEWALS_QUERY_KEY';

import { API_URL } from '@/dtos';

import { RenewalDto } from '../renewals.types';

export const useGetRenewalsQuery = (orgId?: string | null, isEmployerObserving?: boolean) => {
  const { data, isSuccess, isLoading } = useQuery(
    [GET_RENEWALS_QUERY_KEY, orgId, isEmployerObserving],
    () =>
      api.get<RenewalDto[]>(API_URL.RENEWALS, {
        params: {
          ...(orgId && { organization_id: orgId }),
        },
      }),
    {
      retry: 0,
      cacheTime: 0,
      enabled: Boolean(orgId && isEmployerObserving),
    }
  );

  return {
    data: data?.data,
    isLoading,
    isSuccess,
  };
};

export default useGetRenewalsQuery;
